import { StageDaily } from './StageDaily'
import { StageIdea } from './StageIdea'
import { StageLibrary } from './StageLibrary'
import { StagePodcast } from './StagePodcast'
import { StageQuestion } from './StageQuestion'
import { StageReward } from './StageReward'
import { StageStart } from './StageStart'
import { StageTask } from './StageTask'
import { StageText } from './StageText'
import { StageVideo } from './StageVideo'

const iconsMap = {
  start: StageStart,
  text: StageText,
  daily: StageDaily,
  library: StageLibrary,
  reward: StageReward,
  podcast: StagePodcast,
  idea: StageIdea,
  task: StageTask,
  question: StageQuestion,
  video: StageVideo
}

export type Icon = keyof typeof iconsMap

const getIcon = (icon: Icon) => {
  return iconsMap[icon]
}

export {
  StageStart,
  StageText,
  StageDaily,
  StageLibrary,
  StageReward,
  StagePodcast,
  StageIdea,
  StageTask,
  StageQuestion,
  StageVideo,
  iconsMap,
  getIcon
}
